import LicenseStats from './LicenseStats'

export default LicenseStats